export function isInShadow(node: Node): boolean {
  return node.getRootNode() instanceof ShadowRoot;
}

export function appendStylesheet({ target, styles, name }: { target: Node; styles: string; name: string; }) {
  const rootNode: HTMLElement | ShadowRoot = isInShadow(target) ? target.getRootNode() as ShadowRoot : document.body;

  if (!rootNode.querySelector(`[${name}]`)) {
    const styleEl = document.createElement('style');
    styleEl.setAttribute(name, '');
    styleEl.innerHTML = styles;
    rootNode.appendChild(styleEl);
  }
}

export type deferred = {
  promise: Promise<void>,
  resolve: () => void,
  reject: () => void
};

export function makeDeferred(): deferred {
  const def: any = {};
  def.promise = new Promise((resolve, reject) => {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}

export type Constructor<T> = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new(...args: any[]): T;
  selector: string;
};

/**
 * Allow for custom element classes with private constructors
 */
type CustomElementClass = Omit<typeof HTMLElement & { selector: string }, 'new'>;

export type CustomElementDecorator = {
  // legacy
  (cls: CustomElementClass): void;

  // standard
  (
    target: CustomElementClass,
    context: ClassDecoratorContext<Constructor<HTMLElement>>
  ): void;
};

/**
 * Class decorator factory that defines the decorated class as a custom element.
 *
 * ```js
 * @customElement('my-element')
 * class MyElement extends LitElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 * @category Decorator
 * @param tagName The tag name of the custom element to define.
 */
export const c11nElement =
  (): CustomElementDecorator =>
    (
      classOrTarget: (CustomElementClass | Constructor<HTMLElement>) & { selector: string },
      context?: ClassDecoratorContext<Constructor<HTMLElement>>
    ) => {
      if (!customElements.get(classOrTarget.selector)) {
        if (context !== undefined) {
          context.addInitializer(() => {
            customElements.define(
              classOrTarget.selector,
              classOrTarget as CustomElementConstructor
            );
          });
        } else {
          customElements.define(classOrTarget.selector, classOrTarget as CustomElementConstructor);
        }
      }

    };
  